// Typing dots component for conversation-style loading indicator

import { Box } from "@mui/material";

// Shows 3 dots that appear sequentially (1, then 2, then 3, then repeat)
export default function TypingDots() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0,
        "@keyframes typingDot": {
          "0%, 50%, 100%": {
            opacity: 0.6,
            transform: "scale(0.4)",
          },
          "30%": {
            opacity: 1,
            transform: "scale(0.5)",
          },
        },
      }}
    >
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            pt: 1,
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "white",
            animation: "typingDot 1.5s infinite ease-in-out",
            animationDelay: `${index * 0.1}s`,
          }}
        />
      ))}
    </Box>
  );
}
